import { useTranslation } from 'react-i18next';
import { type AllSportsItems, variant } from '@cx-web/domain-types';

import Icon from '../../../../primitives/icon/index';
import { useDesktopHeaderTracking } from '../../context/DesktopHeaderTrackingContext';
import { mergePersistentParams } from '../../utils/merge-persistent-params';

import styles from './HeaderAllSports.module.css';

interface HeaderAllSportsProps {
  items: AllSportsItems;
  onClose: () => void;
  serverUrl?: string;
}

export const HeaderAllSports = (props: HeaderAllSportsProps) => {
  const { items, serverUrl } = props;
  const { t } = useTranslation('label');

  const { allLinks, featuredLinks } = items;
  const requestUrl = serverUrl;
  const track = useDesktopHeaderTracking();

  return (
    <div className={styles.container} data-testid="header-all-sports">
      <div className={styles.content}>
        <div className={styles.headerWrapper}>
          <h2 className={styles.sectionHeader} data-testid="header-all-sports-odds">
            {t('CX_SPORTS_ODDS')}
          </h2>

          <button className={styles.closeIcon} data-testid="header-all-sports-close" onClick={props.onClose}>
            <Icon height={16} icon="Close" width={16} />
          </button>
        </div>

        <div className={styles.linkWrapper} data-testid="header-all-sports-link-wrapper">
          <div className={styles.featuredLinks}>
            {(featuredLinks || []).map((featuredGroup, index) => (
              <section data-testid="header-all-sports-featured-link-section" key={`featuredLinks-${index}`}>
                <ul>
                  {featuredGroup.links.map(({ link, name }) => (
                    <li
                      data-testid="header-all-sports-featured-link-section-item"
                      key={`featuredLinks-${index}-${name}`}
                    >
                      <a
                        className={styles.link}
                        href={mergePersistentParams(link || '', requestUrl)}
                        onClick={() => track(variant.secondary, name)}
                      >
                        {name}
                      </a>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>

          <div className={styles.allLinks}>
            {(allLinks || []).map((linkGroup, index) => (
              <section data-testid="header-all-sports-all-link-section" key={`allLinks-${index}`}>
                <div className={styles.linkGroupWrapper}>
                  <Icon className={styles.icon} height={14} icon={linkGroup.icon} width={14} />
                  <a
                    className={styles.subHeader}
                    data-testid="header-all-sports-all-link-group"
                    href={mergePersistentParams(linkGroup.link || '', requestUrl)}
                    onClick={() => track(variant.secondary, linkGroup.name)}
                  >
                    {linkGroup.name}
                  </a>
                </div>
                <ul>
                  {linkGroup.subLinks.map(({ link, name }) => (
                    <li data-testid="header-all-sports-all-link-group-sublink" key={`allLinks-${index}-${name}`}>
                      <a
                        className={styles.subLink}
                        href={mergePersistentParams(link || '', requestUrl)}
                        onClick={() => track(variant.secondary, name)}
                      >
                        {name}
                      </a>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
